<template>
  <HKLViewLayout
    v-if="inspector"
    :checkIsHKL="true"
  >
    <div class="inline-block inspector-container">
      <div class="row">
        <label class="small-4">
          {{ $t('project.submission.inspector') }}
        </label>
      </div>
      <div class="row">
        <div class="small-4">
          <p>{{ (inspector || {}).displayName }}</p>
        </div>
      </div>
    </div>
  </HKLViewLayout>
</template>

<script>
import { computed } from 'vue-demi'
import lodash from 'lodash'
import HKLViewLayout from '@/controls/Layout/HKLViewLayout.vue'

export default {
  components: {
    HKLViewLayout,
  },
  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    const inspector = computed(() => {
      return lodash.get(props.submission, 'invoice.inspector')
    })
    return {
      inspector,
    }
  },
}
</script>

<style lang="scss" scoped>
.inline-block {
  display: inline-block;
  vertical-align: top;
}
.inspector-container {
  width: 19.5%;
}
</style>
